/*
 * Copyright (c) 2025-2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React, {Component} from 'react';
import {ERROR, INFO, WARNING} from "../../redux/actions.jsx";
import {motion} from "motion/react";
import {Subscription} from "subscription"
import Strings from 'toolbox/strings';
import Time from 'toolbox/time';
import {Notification} from "../../Notification.jsx";

class UiElementInlineError extends Component {
    constructor() {
        super();
        this.state = {
            errors: [],
            lastUpdate: Time.now()
        }

        this.sub = new Subscription()
        this.inputRef = React.createRef()
    }

    componentDidMount() {
        this.sub.add(() => Notification.onChange(() => {
            if (!Strings.isUndefined(this.props.uiId)) {
                let globalErrorList = Notification.getAll()
                let newErrorForThisElement = globalErrorList.filter(error => (error.data.uiElementId === this.props.uiId && error.timestamp > this.state.lastUpdate))
                if (newErrorForThisElement.length !== 0) {
                    this.setState({errors: newErrorForThisElement, lastUpdate: Time.now()})
                }
            }
        }))

    }

    componentWillUnmount() {
        this.sub.unmount()
    }

    render() {

        return (
            <div className={""}>
                {this.state.errors.map(item => {
                    if (item.type === INFO) {
                        return <>
                            <motion.div className="bg-blue-200 p-3 m-2.5 rounded-xl"
                                        initial={{opacity: 0, y: 15}}
                                        animate={{opacity: 1, y: 0}}
                                        exit={{opacity: 0, y: 10}}
                                        transition={{
                                            type: "spring",
                                            stiffness: 350,
                                            damping: 35
                                        }}>
                                <div className="flex items-center justify-between">
                                    <h2 className="text-md font-medium text-gray-800"
                                    >{item.data.title}</h2>
                                </div>
                                <div className="mt-1">
                                    <p className="text-sm text-gray-800">{item.data.text}</p>
                                </div>
                            </motion.div>

                        </>

                    } else if (item.type === WARNING) {
                        return <>
                            <motion.div className="bg-orange-200 p-3 m-2.5 rounded-xl"
                                        initial={{opacity: 0, y: 15}}
                                        animate={{opacity: 1, y: 0}}
                                        exit={{opacity: 0, y: 10}}
                                        transition={{
                                            type: "spring",
                                            stiffness: 350,
                                            damping: 35
                                        }}
                            >
                                <div className="flex items-center justify-between">
                                    <h2 className="text-md font-medium text-gray-800"
                                    >{item.data.title}</h2>
                                </div>
                                <div className="mt-1">
                                    <p className="text-sm text-gray-800">{item.data.text}</p>
                                </div>
                            </motion.div>

                        </>

                    } else if (item.type === ERROR) {
                        return <>
                            <motion.div className="bg-red-300 p-3 m-2.5 rounded-xl"
                                        initial={{opacity: 0, y: 15}}
                                        animate={{opacity: 1, y: 0}}
                                        exit={{opacity: 0, y: 10}}
                                        transition={{
                                            type: "spring",
                                            stiffness: 350,
                                            damping: 35
                                        }}
                            >
                                <div className="flex items-center justify-between">
                                    <h2 className="text-md font-medium text-gray-800"
                                    >{item.data.title}</h2>
                                </div>
                                <div className="mt-1">
                                    <p className="text-sm text-gray-800">{item.data.text}</p>
                                </div>
                            </motion.div>

                        </>

                    }


                })}


            </div>
        );
    }
}

UiElementInlineError.propTypes = {};

export default UiElementInlineError;
